export const getNodePositionId = (workflowId: string, nodeId: string): string =>
  `node-position-${workflowId}-${nodeId}`;
